export default __webpack_public_path__ + "static/media/poc_three.4547a8e9.glb";